import { render, staticRenderFns } from "./FormWizardAdd.vue?vue&type=template&id=1048dfff&"
import script from "./FormWizardAdd.vue?vue&type=script&lang=js&"
export * from "./FormWizardAdd.vue?vue&type=script&lang=js&"
import style0 from "./FormWizardAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports